export default function Style(){
  return (
    <style>
      {`
       .lh-36{
    line-height: 36px;
}
@media screen and (max-width: 1543px) {
  .fs-24-36 {
    font-size: 22px !important;
    line-height: 33px !important;
  }
}
@media screen and (min-width: 1543px) {
  .fs-24-36 {
    font-size: 24px !important;
    line-height: 36px !important;
  }
}
        `}
    </style>
  );
}
